import { IAppState } from 'src/store/types';

export const getPlacement = (state: IAppState) => state.placement;
